export var getCanDvr=function(r,n,t){return!n||t>r};